export const dcFieldPermissions = {
    1093: { addressLine1Text: false, addressLine2Text: false, addressLine3Text: false, cityName: true, stateProvinceCode: true, postalCode: true },
    1081: { addressLine1Text: true, addressLine2Text: true, addressLine3Text: true, cityName: true, stateProvinceCode: true, postalCode: true },
    // Add more DC codes as needed
};

export function isAddressLine1TextEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.addressLine1Text ?? false;
}

export function isAddressLine2TextEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.addressLine2Text ?? false;
}

export function isAddressLine3TextEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.addressLine3Text ?? false;
}

export function isCityNameEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.cityName ?? false;
}

export function isStateProvinceCodeEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.stateProvinceCode ?? false;
}

export function isPostalCodeEditable(dcCode) {
    return dcFieldPermissions[dcCode]?.postalCode ?? false;
}
